import request from '@utils/axiosWrapper';
import * as Ids from '@utils/ids';
import {
    IAllPoiList,
    IKangarooInfo,
    IBusinessStatus,
    IChangeBusinessStatus,
    IUnreadMessageCount,
    IQueryMenu,
    IcustomerServiceInfo,
    CompensateProtocalType,
    ICombineOrderNotice,
    ICheckSCIndex,
    IBetterAuth,
} from './define';

type BusinessStatusParams = {
    status: number;
};

/**
 * 获取所有门店
 */
const getAllPoiList = () => request.postAsFormSubmit<IAllPoiList[]>('/api/poi/poiList');

/**
 * 获取门店袋鼠店长信息
 */
const getPoiKangarooInfo = () =>
    request.get<IKangarooInfo>('/api/poi/poiStatus', {
        params: { wmPoiId: Ids.getWmPoiId() },
    });

/**
 * 获取商家营业状态信息
 */
const getBusinessStatus = () =>
    request.rawPost<IBusinessStatus>('/common/businessStatus', {
        wmPoiId: Ids.getWmPoiId(),
    });

/**
 * 变更营业状态
 */
const changeBusinessStatus = (params: BusinessStatusParams) =>
    request.rawPostAsFormSubmit<{ code: number; msg: string; data: IChangeBusinessStatus }>(
        '/api/poi/change_status',
        {
            ...params,
            wmPoiId: Ids.getWmPoiId(),
            token: Ids.getToken(),
        },
    );

/**
 * 获取未读消息数量
 */
const getUnreadMessageCount = () =>
    request.postAsFormSubmit<IUnreadMessageCount[]>('/gw/v2/shop/msgbox/category/unreadcount', {
        wmPoiId: Ids.getWmPoiId(),
        token: Ids.getToken(),
        acctId: Ids.getAcctId(),
        appType: 3,
    });

/**
 * 获取菜单列表
 */
const getQueryMenu = () =>
    request.rawGet<{ code: number; data: IQueryMenu; msg: string }>('/queryMenu');

/**
 * 菜单权限控制 （目前只用于配送服务）
 */
const getMenuAuth = () =>
    request.get<string>('/v2/common/menu/r/authority', {
        params: {
            wmPoiId: Ids.getWmPoiId(),
            menuName: '订单赔付,出餐时间',
        },
    });

/** 获取待处理餐损赔付订单数 */
const getLossCompensateOrderUnprocessedCount = () => {
    return request.get<number>('/v2/order/common/r/lossCompensate/count', {
        params: { wmPoiId: Ids.getWmPoiId() },
    });
};

/** 获取待处理退款订单数 */
const getUnprocessedRefundOrderCount = () => {
    return request.get<{
        refundCountLoopInterval: number;
        toRefundCount: number;
    }>('/v2/order/history/r/refundOrderCount/notify');
};

/**
 * 智能客服配置
 */
const customerServiceInfo = (params: { sceneType: number }) =>
    request.postAsFormSubmit<IcustomerServiceInfo>('/gw/api/scs/r/info', {
        ...params,
        referId: '',
        appType: 3,
    });

/**
 * 智能客服 - 映射关系
 */
const getCustomerServiceScene = () => request.postAsFormSubmit('/gw/api/scs/r/getSceneTypeInfo');

/**
 * 紧急提示
 */
const getUrgenMessage = () => request.get('/v2/common/r/privacyPhone/sendMessage');

/**
 * 非SLA商家7折赔付留痕
 */
const getCompensateProtocal = (params?: { signStatus: number }) =>
    request.get<CompensateProtocalType>('/api/poi/r/poi/compensate/protocol', {
        params: params ? { signStatus: params.signStatus } : '',
    });

/**
 * 换签开始弹窗：只弹1次（门店维度）
 */
const getChangeRemindInfo = () => request.get('/gw/api/rateV2/changeRemindInfo');

/**
 * 统一换签弹框：每天最多提示1次（设备+门店维度）
 */
const getSignChangesign = () =>
    request.postAsFormSubmit('/gw/api/change/sign/changesign', {
        wmPoiId: Ids.getWmPoiId(),
    });

/**
 * menu-商品待处理tag数
 */
const getLowQualitySpusCount = () =>
    request.get<number>('/reuse/product/food/quality/r/getLowQualitySpusCount', {
        params: { wmPoiId: Ids.getWmPoiId() },
    });

/**
 * 拼好饭拼单一起送-拼好饭
 */
const combineOrderNoticePHF = () =>
    request.get<ICombineOrderNotice>('/gw/phf/api/notice/combineOrder');

/** 是否闪购首页 */
const checkSCIndex = () =>
    request.rawGet<{ code: number; data: ICheckSCIndex }>('/v2/index/r/scIndex');

/**
 * 获取商家账号是否属于品牌账号 310、600
 */
const getBetterAuth = () => request.get<IBetterAuth>('/gw/bizdata/better/auth');

/**
 * 获取定时弹窗配置信息
 */
const getTimerConfig = (bizToken: string) =>
    request.get<{ bizToken: string; period: { startTime: number; endTime: number } }[]>(
        '/gw/api/poi/remind/timer/config',
        {
            params: { wmPoiId: Ids.getWmPoiId(), bizToken },
        },
    );

/**
 * 获取定时弹窗展示信息
 */
const getTimerInfo = (bizToken: string) =>
    request.get<{ bizToken: string; isShow: boolean; title: string; content: string }[]>(
        '/gw/api/poi/remind/timer/info',
        {
            params: { wmPoiId: Ids.getWmPoiId(), bizToken },
        },
    );

export {
    getAllPoiList,
    getPoiKangarooInfo,
    getBusinessStatus,
    changeBusinessStatus,
    getUnreadMessageCount,
    getQueryMenu,
    getMenuAuth,
    getLossCompensateOrderUnprocessedCount,
    getUnprocessedRefundOrderCount,
    customerServiceInfo,
    getCustomerServiceScene,
    getUrgenMessage,
    getCompensateProtocal,
    getChangeRemindInfo,
    getSignChangesign,
    getLowQualitySpusCount,
    combineOrderNoticePHF,
    checkSCIndex,
    getBetterAuth,
    getTimerInfo,
    getTimerConfig,
};
